/**
 * EmojiPicker — M2.3.1 · Picker leggero per composer messaggi Staff.
 *
 * Design: nessuna dipendenza aggiuntiva. Set curato di ~64 emoji comuni
 * organizzate per gruppo, con toggle popover controllato dal parent.
 *
 * UX:
 *  - click su un emoji → chiama `onSelect(emoji)`
 *  - non chiude automaticamente il picker (permette selezioni multiple)
 *  - "Chiudi" esplicito per collassarlo
 *  - funziona con touch (i button hanno area >=32px)
 */
import React from "react";
import { X } from "lucide-react";

const EMOJI_GROUPS = [
  { label: "Volti", items: ["😀", "😃", "😄", "😁", "😊", "😍", "🥰", "😘",
                              "😉", "😎", "🤔", "😐", "😅", "😂", "🤣", "😢",
                              "😭", "😡", "🥺", "😴", "🤗", "🤩", "😇", "🤝"] },
  { label: "Gesti",  items: ["👍", "👎", "👌", "🙏", "👏", "🙌", "💪", "✌️",
                              "🤞", "👋", "🤙", "🫶"] },
  { label: "Cuori",  items: ["❤️", "💚", "💙", "💜", "🧡", "💛", "🖤", "🤍",
                              "💖", "💕", "💔"] },
  { label: "Simboli",items: ["✅", "❌", "⭐", "🔥", "💯", "🎉", "🎊", "🚀",
                              "🍀", "☀️", "🌙", "⚡"] },
  { label: "Sarabi", items: ["🍹", "🍸", "🍷", "🍺", "🍕", "🍔", "🥗", "🍝",
                              "🏖️", "🌊", "☕", "🥂"] },
];

export function EmojiPicker({ open, onSelect, onClose }) {
  if (!open) return null;
  return (
    <div
      data-testid="emoji-picker"
      role="dialog"
      className="absolute bottom-full mb-2 left-0 z-30 w-[320px]
                  max-h-[300px] overflow-y-auto rounded-2xl border-2 border-sand-300
                  bg-white shadow-xl p-3"
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-ink-500">Emoji</span>
        <button
          type="button"
          data-testid="emoji-picker-close"
          onClick={onClose}
          className="p-1 rounded-full hover:bg-sand-100"
        >
          <X className="w-4 h-4 text-ink-500" />
        </button>
      </div>
      {EMOJI_GROUPS.map((g) => (
        <div key={g.label} className="mb-2">
          <div className="text-[10px] uppercase tracking-wide text-ink-400 mb-1">
            {g.label}
          </div>
          <div className="grid grid-cols-8 gap-1">
            {g.items.map((emo) => (
              <button
                key={emo}
                type="button"
                data-testid={`emoji-btn-${emo}`}
                onMouseDown={(e) => e.preventDefault()}   // preserva focus textarea
                onClick={() => onSelect(emo)}
                className="w-8 h-8 flex items-center justify-center rounded-lg
                            hover:bg-sand-100 text-lg leading-none"
              >
                {emo}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
